module.exports = __webpack_public_path__ + "static/media/ic_sticky.e7f63f4e.svg";